import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=3825cedc&scoped=true&"
import script from "./vouchers.vue?vue&type=script&lang=js&"
export * from "./vouchers.vue?vue&type=script&lang=js&"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=3825cedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825cedc",
  null
  
)

export default component.exports